import styled from 'styled-components';

const TagBlock = styled.span`
  position: relative;
  top: 0px;
  float: left;
  display: inline-block;
  padding: 3px 6px;
  margin-right: 5px;
  font-size: 10px;
  line-height: 14px;
  color: #666;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
`;

export default TagBlock;
